"use client";

import React from "react";
import EditSection, { TextEditor, ListItemEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function SaasPricingEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  const defaultPlans = [
    { name: "Starter", price: "29", period: "/mo", desc: "For individuals", features: ["1 User", "10 Projects", "Basic Support"], buttonText: "Start Trial", link: "#" },
    { name: "Pro", price: "79", period: "/mo", desc: "For growing teams", features: ["Unlimited Users", "50 Projects", "24/7 Support"], buttonText: "Get Pro", link: "#" }
  ];

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Headers</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Simple, transparent pricing"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Pricing Plans</h4>
            <ListItemEditor
              label="Plans"
              items={content.plans || defaultPlans}
              itemSchema={[
                { key: "name", label: "Plan Name", type: "text" },
                { key: "price", label: "Price ($)", type: "text" },
                { key: "period", label: "Period (e.g. /mo)", type: "text" },
                { key: "desc", label: "Description", type: "text" },
                { key: "buttonText", label: "Button Label", type: "text" },
                { key: "link", label: "Button Link", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, plans: items })}
              addItemText="Add Plan"
            />
          </div>
        </div>
      }
    />
  );
}
